import React from 'react'
import { X, Link, Plus } from 'lucide-react'
import { designTokens } from '@/utils/design-tokens'

interface PerformanceAddSelectionModalProps {
  isOpen: boolean
  onClose: () => void
  onSelectLinkTask: () => void
  onSelectCreateNew: () => void
}

const PerformanceAddSelectionModal: React.FC<PerformanceAddSelectionModalProps> = ({
  isOpen,
  onClose,
  onSelectLinkTask,
  onSelectCreateNew
}) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      data-modal-overlay
      onMouseDown={(e) => e.stopPropagation()}
      onClick={onClose}
    >
      <div
        className="bg-white rounded border"
        style={{
          borderColor: designTokens.colors.gray[1],
          width: '600px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div 
          className="flex items-center justify-between px-[30px] py-[22px]"
          style={{
            borderBottom: `1px solid ${designTokens.colors.gray[1]}`
          }}
        >
          <h2 
            style={{
              fontFamily: designTokens.typography.fontFamily.sans[0],
              fontSize: '24px',
              fontWeight: 700,
              lineHeight: '1.193359375em',
              color: designTokens.colors.gray[6]
            }}
          >
            세부지표 추가
          </h2>
          <button
            onClick={onClose}
            className="flex items-center justify-center w-6 h-6 hover:bg-gray-100 rounded transition-colors"
          >
            <X 
              className="w-3 h-3" 
              style={{ 
                color: designTokens.colors.gray[5],
                strokeWidth: '2px'
              }} 
            />
          </button>
        </div>

        {/* Content */}
        <div className="px-[30px] py-[40px]">
          <div className="flex items-center justify-center gap-6">
            {/* 세부실행과제 연결 */}
            <div
              className="flex flex-col items-center justify-center gap-[30px] border-2 rounded cursor-pointer hover:shadow-md transition-shadow"
              style={{
                width: '200px',
                height: '150px',
                borderColor: designTokens.colors.gray[1]
              }}
              onClick={onSelectLinkTask}
            >
              <div
                className="flex items-center justify-center"
                style={{
                  width: '36px',
                  height: '36px'
                }}
              >
                <Link 
                  className="w-[30px] h-[30px]" 
                  style={{ 
                    color: designTokens.colors.gray[5],
                    strokeWidth: '2px'
                  }} 
                />
              </div>
              <div
                style={{
                  fontFamily: designTokens.typography.fontFamily.sans[0],
                  fontSize: '20px',
                  fontWeight: 600,
                  lineHeight: '1.193359375em',
                  color: designTokens.colors.black,
                  textAlign: 'center'
                }}
              >
                세부실행과제 연결
              </div>
            </div>

            {/* 신규 성과 생성 */}
            <div
              className="flex flex-col items-center justify-center gap-[30px] border-2 rounded cursor-pointer hover:shadow-md transition-shadow"
              style={{
                width: '200px',
                height: '150px',
                borderColor: designTokens.colors.gray[1]
              }}
              onClick={onSelectCreateNew}
            >
              <div
                className="flex items-center justify-center"
                style={{
                  width: '36px',
                  height: '36px'
                }}
              >
                <Plus 
                  className="w-[21px] h-[21px]" 
                  style={{ 
                    color: designTokens.colors.gray[5],
                    strokeWidth: '2px'
                  }} 
                />
              </div>
              <div
                style={{
                  fontFamily: designTokens.typography.fontFamily.sans[0],
                  fontSize: '20px',
                  fontWeight: 600,
                  lineHeight: '1.193359375em',
                  color: designTokens.colors.black,
                  textAlign: 'center'
                }}
              >
                신규 세부지표 생성
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PerformanceAddSelectionModal